import React from 'react'
import './src/resources/styles/style.scss'
import LocActWrapper from './src/components/templates/LocActWrapper'

export const wrapPageElement = ({ element, props }) => {
  if (props?.pageContext?.locAct) {
    // wrap element in LocActPage
    return <LocActWrapper {...props}>{element}</LocActWrapper>
  }
  return element
}

export const shouldUpdateScroll = ({
}) => false
